type Input = {
    leadDetailsScopeLoanRequestId: string | null;
    routeLeadId: string | undefined;
    visibleLoanRequestIds: Array<string> | undefined;
};

// Lead the chat works against: explicit panel scope > lead page being viewed (if linked + visible) > first visible link.
export const resolveChatContextLoanRequestId = ({
    leadDetailsScopeLoanRequestId,
    routeLeadId,
    visibleLoanRequestIds,
}: Input): string | undefined => {
    if (leadDetailsScopeLoanRequestId) return leadDetailsScopeLoanRequestId;
    if (routeLeadId && visibleLoanRequestIds?.includes(routeLeadId)) return routeLeadId;
    return visibleLoanRequestIds?.[0];
};
